// Used to titleize a string
// Examples:
// "hello_world" returns "Hello World"
// "hello_world, good_morning" returns "Hello World, Good Morning"
// "hello" returns "Hello"

const toTitleCase = string => {
  const withSpaces = string.split("_").join(" ");
  return withSpaces.replace(
    /\w\S*/g,
    txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

export default toTitleCase;
